define('core/helper/LocalStorageCss',[
	'module',
	'core/RequireJsConfig',
], function (rModule, RequireJsConfig) {
	'use strict';

	function noop() {}
	var NOW = +new Date();
	var CACHE_TIME = 6 * 60 * 60 * 1000; // 6 hours in milliseconds!
	var STORAGE_PREFIX = 'loadCSS-';
	var base = RequireJsConfig.baseUrl + '../';
	var noCacheEnabled = /no_cache|noCache/.test(RequireJsConfig.urlArgs(rModule.id, rModule.uri));

	var localStorage = {};
	try {
		// We set up a proxy variable to help with localStorage, e.g. when cookies are disabled
		// and the browser prevents us accessing it.
		// Otherwise some exceptions can be thrown which completely prevent font loading.
		localStorage = window.localStorage || {};
	}
	catch(ex) {}


	var module = {
		linkCSS: linkCSS,
		loadCSS: loadCSS,
		loadFont: loadFont,
		loadModuleCSS: loadModuleCSS,
	};

	var ref = document.getElementsByTagName('script')[0];

	function inlineCSS(id, content, media, beforeCallBack) {
		// If the file was already inlined, do nothing
		if (document.getElementById(id) !== null) {
			return;
		}

		var style = document.createElement('style');

		if (typeof beforeCallBack === 'function') {
			beforeCallBack.apply(null, [id, content, media]);
		}

		style.id = id;
		style.media = media || 'all';
		// style.innerHTML = content;
		style.textContent = content;

		// inject link
		ref.parentNode.insertBefore(style, ref);
	}

	// Source: https://github.com/filamentgroup/loadCSS/blob/master/loadCSS.js
	function linkCSS(href, before, media) {
			// Arguments explained:
			// `href` [REQUIRED] is the URL for your CSS file.
			// `before` [OPTIONAL] is the element the script should use as a reference for injecting our stylesheet <link> before
				// By default, loadCSS attempts to inject the link after the last stylesheet or script in the DOM. However, you might desire a more specific location in your document.
			// `media` [OPTIONAL] is the media type or query of the stylesheet. By default it will be 'all'

			// @TODO: check if the stylesheet is already included with media!
			var check = document.querySelector('link[href="'+ href +'"]');
			if (check) {
				return null;
			}

			var ss = document.createElement('link');
			var ref;
			if (before){
				ref = before;
			}
			else if(document.querySelectorAll){
				var refs = document.querySelectorAll('style,link[rel=stylesheet],script');
				// No need to check length. This script has a parent element, at least
				ref = refs[ refs.length - 1];
			}
			else {
				ref = document.getElementsByTagName('script')[0];
			}

			var sheets = document.styleSheets;
			ss.rel = 'stylesheet';
			ss.href = href;
			// temporarily set media to something inapplicable to ensure it'll fetch without blocking render
			ss.media = 'only x';

			// Inject link
				// Note: the ternary preserves the existing behavior of "before" argument, but we could choose to change the argument to "after" in a later release and standardize on ref.nextSibling for all refs
				// Note: `insertBefore` is used instead of `appendChild`, for safety re: http://www.paulirish.com/2011/surefire-dom-element-insertion/
			ref.parentNode.insertBefore(ss, (before ? ref : ref.nextSibling));
			// A method (exposed on return object for external use) that mimics onload by polling until document.styleSheets until it includes the new sheet.
			ss.onloadcssdefined = function(cb){
				var defined;
				for(var i = 0; i < sheets.length; i++){
					if(sheets[ i ].href && sheets[ i ].href === ss.href){
						defined = true;
					}
				}
				if(defined){
					cb();
				} else {
					setTimeout(function() {
						ss.onloadcssdefined(cb);
					});
				}
			};

			// once loaded, set link's media back to `all` so that the stylesheet applies once it loads
			ss.onloadcssdefined(function() {
				ss.media = media || 'all';
			});
			return ss;

	}

	function loadCSS(href, media, force, beforeCallBack, asLink, errorCallback) {

		setTimeout(function() {

			media = media || 'all';
			force = force || false;
			beforeCallBack = beforeCallBack || noop;
			asLink = asLink || noCacheEnabled;

			if (noCacheEnabled) {
				href += '?no_cache='+ NOW;
			}

			if (force) {
				console.warn('forced loading of '+ href);
			}

			if (asLink) {
				return linkCSS(href, undefined, media);
			}

			var storageKey = STORAGE_PREFIX + encodeURI(href.trim()),
				tstampKey = storageKey +'-tstamp'
			;


			if (localStorage[storageKey] === undefined
				|| parseInt(localStorage[tstampKey], 10) + CACHE_TIME <= +new Date()
				|| force
			) {
				var xhr = new XMLHttpRequest();
				xhr.open('GET', href, true);
				xhr.onreadystatechange = function () {
					if (xhr.readyState !== 4) {
						return;
					}
					if (xhr.status !== 200) {
						return errorCallback.apply(null, [href, media, xhr]);
					}

					var cssContent = xhr.response || xhr.responseText;
					cssContent = fixInlineUrlForLocalStorage(href, cssContent);

					try {
						localStorage[storageKey] = cssContent;
						localStorage[tstampKey] = NOW;
					}
					catch(ex) {
						console.warn('Setting up localStorage failed!');
					}

					inlineCSS(storageKey, cssContent, media, beforeCallBack);
				};
				xhr.send();
			}
			else {
				inlineCSS(storageKey, localStorage[storageKey], media, beforeCallBack);
			}

		}, 0);

	}


	// inspired by http://bdadam.com/blog/better-webfont-loading-with-localstorage-and-woff2.html
	function loadFont(fontFamily, fileName, media, force) {
		if (fileName === undefined) {
			fileName = base +'css/fonts/'+ fontFamily + (supportsWoff2() ? '.woff2' : '.woff') +'.css';
		}
		loadCSS(fileName, media, force, undefined, undefined, function () {

			if (fileName === undefined) {
				fileName = base +'css/fonts/'+ fontFamily + '.woff.css';
			}
			loadCSS(fileName, media, force);
		});
	}

	function loadModuleCSS(moduleName, fileName, media, force) {

		if (fileName === undefined) {
			fileName = base +'css/modules/'+ moduleName +'.css';
		}
		loadCSS(fileName, media, force);
	}


	function fixInlineUrlForLocalStorage(sourceFile, cssContent) {
		cssContent = cssContent.replace(/url\(([^\)]+)\)/g, function (match, url) {
			if (/data:/.test(url)) {
				return match;
			}

			// Remove the file base name and use its path
			var basePath = sourceFile.replace(/([^\/]+)\.css$/, '');
			// Check if the string has quotes around …
			var quotes = url.match(/^(["']?)([^"']+)\1$/);
			// … and save it to a variable for easier use
			quotes = quotes[1];

			// Only apply the "new" base path, if the URL is not an external or absolute URL
			if (! /^(https?:\/\/|\\\\|\/)/.test(url)) {
				url = basePath + url;
			}
			// Now put the required CSS around the URL
			url = 'url('+ quotes + url + quotes +')';

			return url;
		});

		return cssContent;
	}

	var woff2 = null;
	function supportsWoff2() {
		if (woff2 === null) {
			try {
				/* global FontFace:true */
				var f = new FontFace('t', 'url("data:application/font-woff2,") format("woff2")', {});
				f.load().catch(noop);

				woff2 = f.status === 'loading' || f.status === 'loaded';
			}
			catch (ex) {
				woff2 = false;
			}
		}

		return woff2;
	}

	var Modernizr = require('Modernizr');
	if (Modernizr !== undefined && typeof Modernizr.addTest === 'function') {
		Modernizr.addTest('woff2', supportsWoff2);
	}

	return module;
});

